import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Checkbox from "@material-ui/core/Checkbox";
import Table from "@material-ui/core/Table";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import Fab from "@material-ui/core/Fab";
import {myGrid} from "assets/jss/material-dashboard-react.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const BlueCheckbox = withStyles({
  root: {
    color: "#03A9F4",
    padding: "15px 7px 0 0",
    "&$checked": {
      color: "#03A9F4"
    }
  },
  checked: {}
})(props => <Checkbox color="default" {...props} />);

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    //maxWidth: 360,
    backgroundColor: 'transparent',
  },
  titulo: {
    fontSize: '18px',
    fontWeight: 'bold'
  },
  inline: {
    display: 'inline'
  },
  temRecurso: {
      color: '#3be93b'
  },
  naoTemRecurso: {
    color: 'red'
  },
  simpleValue: {
      textAlign: 'left',
      marginLeft: 10
  },
  statusContainer: {
    display: "flex",
    flexDirection: "row"
  },
  fabButton: {
    position: "fixed",
    right: "40%",
    bottom: "60px",
    width: "250px",
    backgroundColor: "#4caf50",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#53c857",
      color: "#FFFFFF"
    }
  },
  fabButtonMobile: {
    position: "fixed",
    right: "20%",
    bottom: "25px",
    width: "250px",
    backgroundColor: "#4caf50",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#53c857",
      color: "#FFFFFF"
    },
  },
  boxBtnWhatsApp: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 18,
    marginleft: 7,
    width: '180px',
  },
  btnWhatsApp: {
      padding: 4,
      borderRadius: 10,
      background: '#65c452',
      color: '#fff',
      textDecoration: 'none',
      '&:hover': {
          textDecoration: 'none',
      },
      fontWeight: 'bold'
  },
}));

const myGridStyle = makeStyles(myGrid);

 function GridMulta(props) {
  
    // const classesGrid = myGridStyle();
    // const classesTaglabel = myTagLabelStyle();
    const classes = useStyles();
    const classesGrid = myGridStyle();
    const formatDate = (dateString) => new Date(dateString).toLocaleString('pt-br', { year: 'numeric', month: '2-digit', day: '2-digit' });
    const [checkboxPE, setCheckboxPE] = useState(new Map());
    const [quantPE, setQuantPE] = useState(new Map());
    const [checkedItem, setCheckedItem] = useState([]);
    const [showBTNFinalizar, setShowBTNFinalizar] = useState(false);
    const matches = useMediaQuery("(max-width:600px)");

    const defineRouteViewMulta = (tipo, id, guid) => {
      if (tipo === "Veiculo") {
        return "multas/view/" + id;
      } else if (tipo === "Habilitacao") {
        return "../app/multas/habilitacao/view/" + guid;
      }
    };

    useEffect(() => {
      setShowBTNFinalizar(checkedItem.length > 0);
      if(checkedItem.length == 0){
        setCheckboxPE(new Map());
        setQuantPE(new Map());
      }
    }, [checkedItem]);
      
    const handleCheck = (event) => {
      const guid = event.target.name;
      const value = event.target.value;
      const isChecked = event.target.checked;

      if(isChecked){
        if(!checkedItem.includes(value)){
          setCheckedItem([...checkedItem, value]);
        }

        if(quantPE.get(guid) === undefined) {
          setQuantPE(prev => new Map(prev).set(guid, 1));
        } else {
          setQuantPE(prev => new Map(prev).set(guid, quantPE.get(guid) + 1));
        }
      } else {
        setCheckedItem(checkedItem.filter(item => item !== value));

        setQuantPE(prev => new Map(prev).set(guid, quantPE.get(guid) - 1));
      }

      if(checkboxPE.get(guid) === undefined) {
        setCheckboxPE(prev => new Map(prev).set(guid, isChecked));
      }
      
    };
      
    function handleClickFinalizar(e) {
      props.PROPS.history.push({
        pathname: "/app/planos/contratar/forma-pagamento",
        state: {
          guidspesolo: checkboxPE,
          guidsquantity: quantPE
        }
      });
    }

    
  return (
    <div
      style={{
        display: (props.display ? '' : 'none'),
        paddingTop: "2.5%"
      }}
    >
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Comprar Recurso</TableCell>
              <TableCell align="center">Valor</TableCell>
              <TableCell align="center">Auto de Infração</TableCell>
              <Hidden xsDown>
                <TableCell align="center">Pontuação</TableCell>
              </Hidden>
              <TableCell align="center">Data Infração</TableCell>
              {/* <TableCell align="center">Data Recurso</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.multas.map((multa, i) => (
              <TableRow
                key={i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                className={classesGrid.center + " " + classesGrid.boxSimpleLine}
              >
                { multa.TemRecurso ? (
                  <TableCell component="th" scope="row">
                    <Link to={defineRouteViewMulta(multa.Tipo, multa.Id, multa.Guid)} style={{ textDecoration: "none" }}>                      <div className={classes.statusContainer}>
                        <CheckCircleIcon
                          className={classes.temRecurso}
                          style={{ paddingRight: 5 }}
                        />
                        <p>Legal, solicitei</p>
                      </div>
                    </Link>
                  </TableCell>
                ) : 
                  (multa.RecursoOnline ? (
                    multa.Tipo == "Habilitacao" ? (
                      <BlueCheckbox
                        checked={checkboxPE.get(multa.Id + "-" + multa.Tipo)}
                        value={multa.Id + "-" + multa.Tipo}
                        name={"3b56759f-a709-455e-abda-6b9fdb5f3f3d"}
                        onChange={handleCheck}
                      />
                    ) : ("Multa de veículo")
                  ) : (
                    <div className={classes.boxBtnWhatsApp}>
                        <a className={classes.btnWhatsApp} href="https://api.whatsapp.com/send?phone=5521965540660&text=Ol%C3%A1%2C%20vim%20do%20app%20e%20preciso%20de%20ajuda%20com%20meu%20caso." target="_blank" rel="noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 48 48">
                                <path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"></path><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"></path><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"></path><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"></path><path fill="#fff" fill-rule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clip-rule="evenodd"></path>
                            </svg> 
                            <strong>Comprar com Especialista</strong>
                        </a>
                    </div>                        
                    )
                  )
                }
                <TableCell align="center">
                  <Link
                    to={defineRouteViewMulta(multa.Tipo, multa.Id, multa.Guid)}
                    style={{ textDecoration: "none" }}
                  >
                    {`R$ ${multa.ValorSerPago}`}
                  </Link>
                </TableCell>
                <TableCell align="center">
                  <Link
                    to={defineRouteViewMulta(multa.Tipo, multa.Id, multa.Guid)}
                    style={{ textDecoration: "none" }}
                  >
                    {multa.AutoInfracao}
                  </Link>
                </TableCell>
                <Hidden xsDown>
                  <TableCell align="center">
                    <Link to={defineRouteViewMulta(multa.Tipo, multa.Id, multa.Guid)}>
                      {(() => {
                        let valorMulta = parseFloat(multa.ValorSerPago.replace(/[^0-9.-]+/g,""));
                        if (valorMulta <= 8838) return "3";
                        if (valorMulta > 8838 && valorMulta <= 13016) return "4";
                        if (valorMulta > 13016 && valorMulta <= 19523) return "5";
                        if (valorMulta > 19523) return "7";
                      })()}
                    </Link>
                  </TableCell>
                </Hidden>
                <TableCell align="center">
                  <Link to={defineRouteViewMulta(multa.Tipo, multa.Id, multa.Guid)}>
                    {formatDate(multa.DataInfracao)}
                  </Link>
                </TableCell>
                {/* <TableCell align="center">
                  <Link to={defineRouteViewMulta(multa.Tipo, multa.Id, multa.Guid)}>
                    {multa.TemRecurso ? formatDate(multa.DataRecurso) : "-----"}
                  </Link>
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {showBTNFinalizar ? (
        <Fab variant="extended" classes={{root: !matches ? classes.fabButton : classes.fabButtonMobile}} onClick={handleClickFinalizar}>
          Comprar
        </Fab>
      ) : (
        ""
      )}
    </div>
  );
}
export default GridMulta;
